import {
  getSpecializedAgentKey,
  getSpecializedAgentVersion,
  getSpecializedAgentVersions,
  updateSpecializedAgent,
} from '../../services/specialized-agent';

import { type AgentVersionsConfig, useAgentVersionsBase } from './useAgentVersionsBase';

export type { RestoreDialog, SelectVersionResult } from './useAgentVersionsBase';
export type UseAgentVersionsReturn = ReturnType<typeof useAgentVersions>;

const CONFIG: AgentVersionsConfig = {
  fetchVersions: (instanceId, agentId, limit, offset) =>
    getSpecializedAgentVersions(instanceId, agentId, limit, offset),
  fetchVersionsKey: (instanceId, agentId, limit, offset) =>
    getSpecializedAgentVersions.key(instanceId, agentId, limit, offset),
  fetchVersion: url => getSpecializedAgentVersion(url),
  fetchVersionKey: url => getSpecializedAgentVersion.key(url),
  duplicateRoute: agentId => `/agents/specialized/${agentId}/copy`,
  versionsCachePrefix: 'opal:specialized-agent-versions',
  restoreFn: async (agentUrl, fullAgent) => {
    return updateSpecializedAgent(
      agentUrl,
      fullAgent as Parameters<typeof updateSpecializedAgent>[1]
    )();
  },
  onRestoreSuccess: (queryClient, agentId) => {
    queryClient.invalidateQueries({
      predicate: query =>
        Array.isArray(query.queryKey) &&
        query.queryKey.includes('opal:specialized-agent-versions') &&
        query.queryKey.includes(agentId),
    });
    queryClient.invalidateQueries({ queryKey: ['opal:specialized-agents'] });
    queryClient.invalidateQueries({ queryKey: getSpecializedAgentKey(agentId) });
  },
};

export function useAgentVersions(agentId: string) {
  return useAgentVersionsBase(agentId, CONFIG);
}
